module.exports = __webpack_public_path__ + "img/integrations.55098b9f.png";